import { NodeProps } from "reactflow";
import NodeCard from "../NodeCard";
import {
  FlowModuleItemType,
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
} from "@packages/flow-core/module";
import Divider from "../Divider";
import styles from "./index.less";
import RenderInput from "../render/RenderInput";
import { Button, Input, Row, Space } from "antd";
import { MinusCircleFilled } from "@ant-design/icons";
import SourceHandle from "../SourceHandle";
import { useFlow } from "../FlowEdit/useFlow";
import { RenderInputProps } from "../render/RenderInput/types";
import { nanoid } from "nanoid";
import { FlowNodeOutputTypeEnum } from "@packages/flow-core/module/node/constants";
import { memo, useReducer } from "react";

const Agent = memo(({ item, moduleId }: RenderInputProps) => {
  const [, forceUpdate] = useReducer((n) => n + 1, 0);
  const { addModuleOutput, deleteModuleOutput, updateNodeValue } = useFlow();
  const value = (item.value as { key: string; value: string }[]) || [];
  return (
    <>
      {value.map((valueItem, index) => (
        <div key={valueItem.key} className={styles["mb-24"]}>
          <Space>
            <MinusCircleFilled
              onClick={() => {
                const newValue = value.filter((it) => it.key !== valueItem.key);
                deleteModuleOutput(moduleId, item.key);
                updateNodeValue(moduleId, item.key, newValue);
                forceUpdate();
              }}
            />
            {`分类${index + 1}`}
          </Space>
          <div className={styles["pos-rel"]}>
            <Input.TextArea
              defaultValue={valueItem.value}
              onBlur={(e) => {
                const valueItem = {
                  ...item,
                  value: e.target.value,
                };
                const newValue = [...value];
                newValue.splice(index, 1, valueItem);
                updateNodeValue(moduleId, item.key, newValue);
              }}
            />
            <SourceHandle
              handleKey={item.key}
              valueType={ModuleIOValueTypeEnum.boolean}
              moduleId={moduleId}
            />
          </div>
        </div>
      ))}
      <Row justify="end">
        <Button
          size="small"
          type="primary"
          onClick={() => {
            const key = nanoid();
            updateNodeValue(
              moduleId,
              item.key,
              value.concat({ key, value: "" })
            );
            addModuleOutput(moduleId, {
              type: FlowNodeOutputTypeEnum.hidden,
              valueType: ModuleIOValueTypeEnum.boolean,
              key,
              targets: [],
            });
          }}
        >
          添加问题类型
        </Button>
      </Row>
    </>
  );
});

export default memo(function NodeClassifyQuestion({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) {
  const { inputs, moduleId } = data;
  return (
    <NodeCard {...data} selected={selected}>
      <Divider text="输入" />
      <div className={styles.content}>
        <RenderInput
          moduleId={moduleId}
          flowInputList={inputs}
          CustomComponent={{
            [ModuleInputKeyEnum.agents]: Agent,
          }}
        />
      </div>
    </NodeCard>
  );
});
